export default {
  // TIMESHEET
  TIMESHEET_V2_ENABLED: 'timesheet:v2-enabled',
};
